module.exports = __webpack_public_path__ + "lerk.jpg?717b3f8b5746c57e27800556e57365fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/djs/lerk.jpg
// module id = 386
// module chunks = 0